import { render, staticRenderFns } from "./product-details-pricing-v2.vue?vue&type=template&id=93089ebc&scoped=true&"
import script from "./product-details-pricing-v2.vue?vue&type=script&lang=js&"
export * from "./product-details-pricing-v2.vue?vue&type=script&lang=js&"
import style0 from "./product-details-pricing-v2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product-details-pricing-v2.vue?vue&type=style&index=1&id=93089ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93089ebc",
  null
  
)

export default component.exports